import React from 'react';
import { useSalon } from '../../contexts/SalonContext';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../types';
import './SalonSelector.css';

const SalonSelector = () => {
    // Use try-catch to handle if context is not available
    let salonContext;
    try {
        salonContext = useSalon();
    } catch (error) {
        console.warn('SalonSelector: SalonContext not available', error);
        return null; // Don't render if context unavailable
    }

    const { salons, currentSalon, setCurrentSalon } = salonContext;
    const { user } = useAuth();

    // Only owners/admins can switch salons
    const canSwitchSalon = user?.role === UserRole.OWNER || user?.role === UserRole.ADMIN;

    if (!user || !salons || salons.length === 0) return null;

    // If user cannot switch, just show the current salon name static
    if (!canSwitchSalon) {
        return (
            <div className="salon-selector static">
                <span className="salon-icon">🏢</span>
                <span className="salon-name-display">{currentSalon?.name || 'My Salon'}</span>
            </div>
        );
    }

    const handleSalonChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedId = e.target.value;
        const selected = salons.find(s => s.id === selectedId);
        if (selected) {
            setCurrentSalon(selected);
        }
    };

    return (
        <div className="salon-selector-container">
            <div className="salon-select-wrapper">
                <span className="salon-icon">🏢</span>
                <select
                    className="salon-select"
                    value={currentSalon?.id || ''}
                    onChange={handleSalonChange}
                >
                    {salons.map(salon => (
                        <option key={salon.id} value={salon.id}>
                            {salon.name}
                        </option>
                    ))}
                </select>
                <span className="select-arrow">▼</span>
            </div>
        </div>
    );
};

export default SalonSelector;
